import axios from "axios";
import { GET_GOART_BASE_URL } from "~/utils/common";

// 创建axios实例, baseURL为 goart的
const service = axios.create({
  baseURL: GET_GOART_BASE_URL()
});

export default service;